export default __webpack_public_path__ + "static/media/footermobile.00e2919d.jpg";